export default {
  primary: '#233446',
  secondary: '#222e3a',
  accent: '#2FB95F',
  error: '#FF5454',
  info: '#3392F8',
  success: '#2FB95F',
  warning: '#FFCB44',
  highlight: '#F93D81',
  incomplete: '#FF9C54'
};
